import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconInformation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 15C11.625 15 15 11.625 15 7.5C15 3.375 11.625 0 7.5 0C3.375 0 0 3.375 0 7.5C0 11.625 3.375 15 7.5 15ZM7.5 3.75C8.0625 3.75 8.4375 4.125 8.4375 4.6875C8.4375 5.25 8.0625 5.625 7.5 5.625C6.9375 5.625 6.5625 5.25 6.5625 4.6875C6.5625 4.125 6.9375 3.75 7.5 3.75ZM6.5625 6.5625L8.4375 6.5625V11.25H6.5625L6.5625 6.5625Z",
		fill: "currentColor"
	})
});
export default SvgIconInformation;
